<template>
	<div v-if="device=='pc'">
		<box :customer="true" :autoLoad="true" :ref="boxRef" title="新收款" :width="1000" :index="0" @hide="hide" @submit="submit"
			moduleName="collection" :store="store" selectType="radio"
			@boxdataload="boxdataload" />
	
	</div>
	<div v-else>
		<phonebox :customer="true" :autoLoad="true" :ref="boxRef" title="新收款" :width="1000" :index="0" @hide="hide" @submit="submit"
			moduleName="collection" :store="store" selectType="radio"
			@boxdataload="boxdataload" />
	</div>
	
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	//https://detail.tmall.com/item.htm?id=706822484836&spm=a21dvs.23580594.0.0.1d293d0d88sla5 
	import box from '@_system/components/formcomponents/common/box/index.vue'
	import phonebox from '@_system/components/formcomponents/phone/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			supplierwlnid:{
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				index: 0,
				foreingKey:null,
				boxRef: 'box_' + Math.random(),

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box

		},
		watch: {

		},
		computed: {
			device(){
				return window.systemMethods.device()
			}
		},

		methods: {
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box,
			phonebox
		}
	}
</script>
